module.exports = __webpack_public_path__ + "img/i_main_noti.2220df9e.svg";